import React, { useState, useEffect } from "react";
import withApi from "../../higherOrderComponents/withApi";
import { DataDefinitionList, Loader, Notification, Message } from "../../../web.common";

export const Schedule = withApi(({ api, productId }) => {
  const [integrationId, setIntegrationId] = useState(null);
  const [data, setData] = useState(null);
  const [isDisabled, setIsDisabled] = useState(null);
  const [isEditing, setIsEditing] = useState(null);
  const [editedDaysToCrawl, setEditedDaysToCrawl] = useState(null);
  const [editedFirstDayToCrawl, setEditedFirstDayToCrawl] = useState(null);
  const [editedInterval, setEditedInterval] = useState(null);
  const [editedAllowedFromHour, setEditedAllowedFromHour] = useState(null);
  const [editedAllowedToHour, setEditedAllowedToHour] = useState(null);
  const [editNotification, setNotification] = useState(null);

  useEffect(() => {
    async function loadFromApi() {
      const integration = await api.integrations.getIntegrationByProductId(
        productId
      );
      setIntegrationId(integration.Id);
      var response = await api.integrations.getSchedules(integration.Id);

      setData(response);
      setIsDisabled(response.forciblyDisabled);
    }

    if (!data) {
      loadFromApi();
    }
  }, [editNotification]);

  const toggleStatus = async () => {
    if (isDisabled != null) {
        const forciblyDisabled = !isDisabled;
        setIsDisabled(null);
        const response = await api.integrations.updateSchedule({...data, forciblyDisabled: forciblyDisabled});

        setIsDisabled(response.forciblyDisabled);
    }
  };

  const validateInterval = (interval) => {
    if (interval != null && interval > 0) {
      return interval;
    } else {
      setNotification(new Message('warning','The interval must be greater than 0. Set to 5 hours.'));
      return 5;
    }
  }

  const statusHandler = () => {
    const buttonColor = isDisabled == false ?
     "button-color-primary" :
     "button-color-danger";
    const buttonClass = `button button-shrink-limited ${buttonColor}`;
    
    return <button 
    className={buttonClass}
    disabled={isDisabled == null}
    onClick={toggleStatus}>{isDisabled == false ? "Enabled" : "Disabled"}
    </button>;
  };

  return (
    <React.Fragment>
    <Notification newMessage={editNotification} />
      {data == null && <Loader hasLoaded={false} />}
      <h3>Schedule</h3>
      <article className="data-table-wrap">
        <DataDefinitionList
          classNames={["detail-page-list"]}
          listData={{
            ["Status"]: data ? statusHandler() : "",
          }}
        />
        <br />
        <br />
        <button
          type="button"
          className="button button-color-primary button-shrink-limited"
          onClick={async () => {
            await api.integrations.addSchedule({
              daysToCrawl: 0,
              firstDayToCrawl: 0,
              interval: 0,
              allowedFromHour: null,
              allowedToHour: null,
              integrationId: integrationId,
            });
            const loadedSchedules = await api.integrations.getSchedules(
              integrationId
            );
            setData(loadedSchedules);
          }}
        >
          New Schedule
        </button>

        <br></br>
        <br></br>
        <table className="data-lists component-data-table cell-content-align-top">
          <thead>
            <tr style={{ backgroundColor: "#5e5e5e", color: "#f1f1f3" }}>
              <td>Days To Crawl</td>
              <td>First Day To Crawl</td>
              <td>Interval</td>
              <td>Allowed From Hour</td>
              <td>Allowed To Hour</td>
              <td></td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.entries &&
              data.entries.map((whole) => {
                const {
                  id,
                  daysToCrawl,
                  firstDayToCrawl,
                  interval,
                  allowedFromHour,
                  allowedToHour,
                } = whole;

                if (isEditing == id) {
                  return (
                    <tr>
                      <td>
                        <input
                          type="number"
                          value={editedDaysToCrawl}
                          onChange={(e) => {
                            setEditedDaysToCrawl(e.target.value || "");
                          }}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          value={editedFirstDayToCrawl}
                          onChange={(e) => {
                            setEditedFirstDayToCrawl(e.target.value || "");
                          }}
                        ></input>
                      </td>
                      <td>
                        <input
                          type="number"
                          value={editedInterval}
                          onChange={(e) => {
                            setEditedInterval(e.target.value || "");
                          }}
                        ></input>
                      </td>
                      <td>
                        <input
                          type="time"
                          value={editedAllowedFromHour}
                          onChange={(e) => {
                            setEditedAllowedFromHour(
                              e.target.value || undefined
                            );
                          }}
                        ></input>
                      </td>
                      <td>
                        <input
                          type="time"
                          value={editedAllowedToHour}
                          onChange={(e) => {
                            setEditedAllowedToHour(e.target.value || undefined);
                          }}
                        ></input>
                      </td>
                      <td
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setIsEditing(null);
                        }}
                      >
                        Cancel
                      </td>
                      <td
                        style={{ cursor: "pointer" }}
                        onClick={async () => {
                          await api.integrations.updateSchedule(
                            Object.assign(whole, {
                              daysToCrawl: editedDaysToCrawl || 0,
                              firstDayToCrawl: editedFirstDayToCrawl || 0,
                              interval: validateInterval(editedInterval || 0),
                              allowedFromHour: editedAllowedFromHour,
                              allowedToHour: editedAllowedToHour,
                              forciblyDisabled: isDisabled
                            })
                          );
                          const loadedSchedule =
                            await api.integrations.getSchedules(integrationId);
                          setIsEditing(null);
                          setData(loadedSchedule);
                        }}
                      >
                        Save
                      </td>
                    </tr>
                  );
                }
                return (
                  <tr>
                    <td>{daysToCrawl}</td>
                    <td>{firstDayToCrawl}</td>
                    <td>{interval}</td>
                    <td>{allowedFromHour}</td>
                    <td>{allowedToHour}</td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={async () => {
                        const result = confirm(
                          "Are you sure to delete this rule ?"
                        );
                        if (!result) {
                          return;
                        }
                        await api.integrations.deleteSchedule(
                          integrationId,
                          id
                        );
                        const loadedSchedules =
                          await api.integrations.getSchedules(integrationId);
                        setData(loadedSchedules);
                      }}
                    >
                      Delete
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setIsEditing(id);
                        setEditedDaysToCrawl(daysToCrawl);
                        setEditedFirstDayToCrawl(firstDayToCrawl);
                        setEditedInterval(interval);
                        setEditedAllowedFromHour(allowedFromHour);
                        setEditedAllowedToHour(allowedToHour);
                      }}
                    >
                      Edit
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </article>
    </React.Fragment>
  );
});
